/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd';
import useQuery from '../../../util/useQuery';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Sticky, StickyContainer } from 'react-sticky';
import Tab1 from './Tab1';
import Tab3 from './Tab3';
import Tab2 from './Tab2';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import { ROUTER } from '../../../constants/router';
import { t } from 'i18next';
import usePermission from '../../../hooks/usePermission';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{
                    ...style,
                }}
            />
        )}
    </Sticky>
);

const RiskAssessmentDetail = () => {
    const navigate = useNavigate();
    const { riskId } = useParams();
    const params = useQuery();

    const { isAuditor } = usePermission();

    //detail
    const [detailRiskFactor, setDetailRiskFactor] = useState([]);
    const [detailRiskmap, setDetailRiskmap] = useState([]);
    const [detailLikelihood, setDetailLikelihood] = useState([]);
    //mode create || edit
    const [riskFactorMode, setRiskFactorMode] = useState('create');
    const [riskmapMode, setRiskmapMode] = useState('create');
    const [likelihoodMode, setLikelihoodMode] = useState('create');

    const [lastUpdate, setLastUpdate] = useState();

    const getRiskAssessment = async () => {
        const { data } = await RiskAssessmentService.getRiskAssessmentDetail();
        if (data.resultData) {
            // console.log('resultData ',data.resultData)
            setLastUpdate(data.resultData);

            const riskFactor = data.resultData.riskFactor;
            const riskMaps = data.resultData.riskMaps;
            const likelihood = data.resultData.likelihood;

            if (riskFactor.item.length || riskFactor.itemAddOn.length) {
                setDetailRiskFactor(riskFactor);
                // console.log(111)
                setRiskFactorMode('edit');
            }
            if (riskMaps.riskMap.length || riskMaps.riskMapAddOn.length) {
                setDetailRiskmap(riskMaps);
                // console.log(222)
                setRiskmapMode('edit');
            }
            if (likelihood.length) {
                setDetailLikelihood(likelihood);
                // console.log(333)
                setLikelihoodMode('edit');
            }
        }
    };

    useEffect(() => {
        if (isAuditor) {
            navigate(`${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view`);
        }
    }, [riskId, isAuditor]);

    useEffect(() => {
        getRiskAssessment();
    }, []);

    return (
        <StickyContainer>
            <Tabs
                className="tabs"
                onChange={(key) => {
                    return navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}?tab=${key}`
                    );
                }}
                activeKey={params.get('tab') || '1'}
                renderTabBar={renderTabBar}
            >
                <TabPane tab={t('RA.RiskFactor')} key={1}>
                    <Tab1
                        detail={detailRiskFactor}
                        mode={riskFactorMode}
                        getRiskAssessment={getRiskAssessment}
                        lastUpdate={lastUpdate}
                    />
                </TabPane>
                <TabPane tab={t('RA.RiskMap')} key={2}>
                    <Tab2
                        detail={detailRiskmap}
                        mode={riskmapMode}
                        getRiskAssessment={getRiskAssessment}
                        lastUpdate={lastUpdate}
                    />
                </TabPane>
                <TabPane tab={t('RA.Likelihood')} key={3}>
                    <Tab3
                        detail={detailLikelihood}
                        mode={likelihoodMode}
                        getRiskAssessment={getRiskAssessment}
                        lastUpdate={lastUpdate}
                    />
                </TabPane>
            </Tabs>
        </StickyContainer>
    );
};

export default RiskAssessmentDetail;
